import BaseService from './_base.service';

export const jobService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/job/page/"+page+"/"+size, callback)
}
function search(page,size,filter, callback) {
    return BaseService.post("/job/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/job/combo/", callback,)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/job/"+id, body, callback, false)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/job/", body, callback, false)
}

function one(id,callback) {
    return BaseService.get("/job/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/job/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/job/"+id+"/logic", callback);
}
